// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1fnLG","selected":"Chip_selected__1Dbv4"};